import { Routes } from "@angular/router";
import { RaskRoller } from "~app/common/models/constants";
import { DokumentArbetsorderBeteckningComponent } from "../pages/dokument/dokument-arbetsorder-beteckning/dokument-arbetsorder-beteckning.component";
import { dokumentArbetsorderBeteckningResolver } from "../pages/dokument/dokument-arbetsorder-beteckning/dokument-arbetsorder-beteckning.resolvers";
import { DokumentArbetsorderIdComponent } from "../pages/dokument/dokument-arbetsorder-id/dokument-arbetsorder-id.component";
import { dokumentArbetsorderIdResolver } from "../pages/dokument/dokument-arbetsorder-id/dokument-arbetsorder-id.resolver";
import { DokumentVirkeskopIdComponent } from "../pages/dokument/dokument-virkeskop-id/dokument-virkeskop-id.component";
import { dokumentVirkeskopIdResolver } from "../pages/dokument/dokument-virkeskop-id/dokument-virkeskop-id.resolver";
import { DokumentVirkeskopKontraktBilagaComponent } from "../pages/dokument/dokument-virkeskop-kontrakt-bilaga/dokument-virkeskop-kontrakt-bilaga.component";
import { dokumentVirkeskopKontraktBilagaResolver } from "../pages/dokument/dokument-virkeskop-kontrakt-bilaga/dokument-virkeskop-kontrakt-bilaga.resolver";
import { DokumentVirkeskopKontraktComponent } from "../pages/dokument/dokument-virkeskop-kontrakt/dokument-virkeskop-kontrakt.component";
import { dokumentVirkeskopKontraktResolver } from "../pages/dokument/dokument-virkeskop-kontrakt/dokument-virkeskop-kontrakt.resolver";

export const dokumentRoutes: Routes = [
    {
        path: "dokument",
        title: "Hämta dokument",
        children: [
            {
                path: "arbetsorder/:typ/:beteckning",
                title: "Arbetsorder",
                component: DokumentArbetsorderBeteckningComponent,
                data: {
                    requiredRoles: [RaskRoller.role.Titta],
                    editRoles: [RaskRoller.role.Titta]
                },
                resolve: {
                    dokument: dokumentArbetsorderBeteckningResolver
                }
            },
            {
                path: "arbetsorder/:dokumentId",
                title: "Arbetsorder dokument",
                component: DokumentArbetsorderIdComponent,
                data: {
                    requiredRoles: [RaskRoller.role.Titta]
                },
                resolve: {
                    dokument: dokumentArbetsorderIdResolver
                }
            },
            {
                path: "virkeskop/:id/kontrakt/:dokumentId",
                title: "Virkesköps kontrakt",
                component: DokumentVirkeskopKontraktComponent,
                data: {
                    requiredRoles: [
                        RaskRoller.role.Virkeskopa,
                        RaskRoller.role.Kopleda,
                        RaskRoller.role.Kopplanera,
                        RaskRoller.role.Skogsvardsuppdragsplanera
                    ],
                    editRoles: [
                        RaskRoller.role.Virkeskopa,
                        RaskRoller.role.Kopleda,
                        RaskRoller.role.Kopplanera,
                        RaskRoller.role.Skogsvardsuppdragsplanera
                    ]
                },
                resolve: {
                    kontrakt: dokumentVirkeskopKontraktResolver
                }
            },
            {
                path: "virkeskop/:id/kontraktbilaga/:dokumentId",
                title: "Virkesköps kontraktsbilaga",
                component: DokumentVirkeskopKontraktBilagaComponent,
                data: {
                    requiredRoles: [
                        RaskRoller.role.Virkeskopa,
                        RaskRoller.role.Kopleda,
                        RaskRoller.role.Kopplanera,
                        RaskRoller.role.Skogsvardsuppdragsplanera
                    ],
                    editRoles: [
                        RaskRoller.role.Virkeskopa,
                        RaskRoller.role.Kopleda,
                        RaskRoller.role.Kopplanera,
                        RaskRoller.role.Skogsvardsuppdragsplanera
                    ]
                },
                resolve: {
                    kontraktbilaga: dokumentVirkeskopKontraktBilagaResolver
                }
            },
            {
                path: "virkeskop/:id/:dokumentId",
                title: "Virkesköps dokument",
                component: DokumentVirkeskopIdComponent,
                data: {
                    requiredRoles: [
                        RaskRoller.role.Virkeskopa,
                        RaskRoller.role.Kopleda,
                        RaskRoller.role.Kopplanera,
                        RaskRoller.role.Skogsvardsuppdragsplanera
                    ],
                    editRoles: [
                        RaskRoller.role.Virkeskopa,
                        RaskRoller.role.Kopleda,
                        RaskRoller.role.Kopplanera,
                        RaskRoller.role.Skogsvardsuppdragsplanera
                    ]
                },
                resolve: {
                    dokument: dokumentVirkeskopIdResolver
                }
            }
        ]
    }
];
